import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useApplication } from 'app/application/application'
import { PublicRoutes } from 'app/application/types'
import { ArrowRightIcon, ExclamationIcon } from 'app/common/presentation/icons'

import { Button } from 'components'

import styles from './SessionExpired.module.scss'

const SessionExpired = () => {
  const navigate = useNavigate()
  const { setAuthorization } = useApplication()
  const { t } = useTranslation('sessionExpired')

  const navigateToLogin = () => {
    setAuthorization(null)
    void navigate(PublicRoutes.Login)
  }

  return (
    <div className={styles.sessionExpired}>
      <div>
        <ExclamationIcon />
        <div>
          <div>{t('title')}</div>
          <div>{t('description')}</div>
        </div>
        <Button onClick={navigateToLogin} rightIcon={<ArrowRightIcon />}>
          {t('action')}
        </Button>
      </div>
    </div>
  )
}

export default SessionExpired
